import React, { Component, PropTypes } from 'react';

import './InfoBlockRoute.scss';
import RouteItem from './RouteItem';
import AnimakitExpander from 'animakit-expander';
import { getImgStaticMapGoogle } from '../../api';


class InfoBlockRoute extends Component {

    static propTypes = {
        locations: PropTypes.object,
    };

    static defaultProps = {
        locations: {},
    };

    state = {
        staticMapContent: '',
    };

    componentDidMount() {
        this.fetchStaticMap();
    }

    async fetchStaticMap() {
        if (this.props.googleMapsRoute && this.props.locations.from && this.props.locations.to) {
            const staticMapContent = await getImgStaticMapGoogle(
                [this.props.locations.from[0].coords, this.props.locations.to[0].coords],
                this.props.googleMapsRoute,
                "500x200"
            );

            this.setState({ staticMapContent });
        }
    }

    _renderRoute = () => {
        const route = [];
        let counter = 1;

        if (this.props.locations.from && this.props.locations.from[0]) {
            route.push(<RouteItem key="1" text={this.props.locations.from[0].text} counter={counter} />);
            counter++;
        }

        if (this.props.locations.from && this.props.locations.from[1]) {
            route.push(<RouteItem key="2" text={this.props.locations.from[1].text} counter={counter} />);
            counter++;
        }

        if (this.props.locations.to && this.props.locations.to[0]) {
            route.push(<RouteItem key="3" text={this.props.locations.to[0].text} counter={counter} />);
            counter++;
        }

        if (this.props.locations.to && this.props.locations.to[1]) {
            route.push(<RouteItem key="4" text={this.props.locations.to[1].text} counter={counter} />);
        }

        return route;
    }

    render() {
        const { staticMapContent } = this.state;

        return (
            <div className="InfoBlockRoute">
                <AnimakitExpander expanded={staticMapContent !== ''} duration={200}>
                    <div className="AddressControl-staticMap">
                        <img className="AddressControl-staticMapImg" src={staticMapContent} />
                    </div>
                </AnimakitExpander>
                {this._renderRoute()}
            </div>
        )
    }
}


export default InfoBlockRoute;



// WEBPACK FOOTER //
// ./client/components/InfoBlockRoute/InfoBlockRoute.js